// extracted by mini-css-extract-plugin
export var exoticRunners = "ExoticOutcome-module--exoticRunners--877e1";
export var exoticSelections = "ExoticOutcome-module--exoticSelections--3faed";
export var runnerNumber = "ExoticOutcome-module--runnerNumber--b8304";
export var runnersList = "ExoticOutcome-module--runnersList--0086b";
export var won = "ExoticOutcome-module--won--f47b3";